<template>
    <div>
        <ModuleNavDrawer
            v-model="drawer"
            :title="$t('nav.profilesModule.title')"
            brand-icon="mdi-account-cog"
            :items="modules"
            :active-value="activeModule"
            @select="changeModule"
        />
        <PerfisUsuarios v-if="activeModule === 'usuarios'" />
        <PerfisReferentes v-else-if="activeModule === 'referentes'" />
    </div>
</template>

<script>
import ModuleNavDrawer from './ModuleNavDrawer.vue';
import PerfisUsuarios from './PerfisUsuarios.vue';
import PerfisReferentes from './PerfisReferentes.vue';

export const MODULE_DEFS = [
    { value: 'usuarios', icon: 'mdi-account-group', labelKey: 'nav.profilesModule.users' },
    { value: 'referentes', icon: 'mdi-badge-account-horizontal', labelKey: 'nav.profilesModule.referents' },
];

export default {
    name: 'Perfis',
    components: {
        ModuleNavDrawer,
        PerfisUsuarios,
        PerfisReferentes,
    },
    data: () => ({
        drawer: false,
        activeModule: 'usuarios',
    }),
    computed: {
        modules() {
            return MODULE_DEFS.map((mod) => ({
                text: this.$t(mod.labelKey),
                value: mod.value,
                icon: mod.icon,
            }));
        },
    },
    watch: {
        '$route.query.modulo'(val) {
            this.syncModuleFromQuery(val);
        },
    },
    created() {
        this.syncModuleFromQuery(this.$route && this.$route.query ? this.$route.query.modulo : null);
        const current = (this.$route && this.$route.query) || {};
        if (current.modulo !== this.activeModule) {
            this.$router.replace({
                path: '/perfis',
                query: { ...current, modulo: this.activeModule },
            }).catch(() => {});
        }
    },
    methods: {
        syncModuleFromQuery(modulo) {
            const allowed = this.modules.map((m) => m.value);
            if (modulo && allowed.includes(modulo)) {
                this.activeModule = modulo;
                return;
            }
            this.activeModule = 'usuarios';
        },
        changeModule(module) {
            if (!module || module.value == null) return;
            this.activeModule = module.value;
            const current = (this.$route && this.$route.query) || {};
            if (current.modulo === module.value) return;
            const query = { ...current, modulo: module.value };
            this.$router.replace({ path: '/perfis', query }).catch(() => {});
        },
    },
};
</script>
